import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityIndicators = () => {
  const securityFeatures = [
    {
      icon: "Shield",
      title: "SSL Encrypted",
      description: "256-bit encryption protects your data"
    },
    {
      icon: "Lock",
      title: "Secure Storage",
      description: "Your information is safely stored"
    },
    {
      icon: "Eye",
      title: "Privacy First",
      description: "We never sell your personal data"
    }
  ];

  return (
    <div className="bg-success/5 border border-success/20 rounded-organic p-4">
      <div className="flex items-center space-x-2 mb-3">
        <Icon name="ShieldCheck" size={20} className="text-success" />
        <h3 className="text-sm font-body font-body-medium text-foreground">
          Secure Registration
        </h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-center space-x-2">
            <Icon name={feature?.icon} size={14} className="text-success flex-shrink-0" />
            <div>
              <p className="text-xs font-body font-body-medium text-foreground">
                {feature?.title}
              </p>
              <p className="text-xs text-muted-foreground">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-3 pt-3 border-t border-success/20">
        <p className="text-xs text-muted-foreground text-center">
          By creating an account, you agree to our{' '}
          <a href="#" className="text-primary hover:underline">Terms of Service</a>
          {' '}and{' '}
          <a href="#" className="text-primary hover:underline">Privacy Policy</a>
        </p>
      </div>
    </div>
  );
};

export default SecurityIndicators;